import React from 'react';
import '../styles/sessions-page.css';

interface DeleteSessionModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteSessionModal: React.FC<DeleteSessionModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className="delete-session-modal-overlay" onClick={onCancel}>
      <div className="delete-session-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="delete-session-modal-close"
          onClick={onCancel}
          aria-label="Close"
          data-testid="delete-modal-close"
        >
          ×
        </button>

        <div className="delete-session-modal-content">
          <h2 className="delete-session-modal-title">Permanently Delete?</h2>
          <p className="delete-session-modal-message">
            Just checking, are you sure you want to delete this? Once it's gone, you won't be able to get it back.
          </p>
        </div>

        <div className="delete-session-modal-footer">
          <button
            className="delete-session-modal-button cancel"
            onClick={onCancel}
            data-testid="delete-modal-cancel"
          >
            No, cancel
          </button>
          <button
            className="delete-session-modal-button confirm"
            onClick={onConfirm}
            data-testid="delete-modal-confirm"
          >
            Yes, delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteSessionModal;

